export default __webpack_public_path__ + "static/media/aiot_logo.7ba6800a.png";